import { h } from 'preact'
import { useState } from 'preact/hooks'
import { connect } from 'unistore/preact'
import { Button, Form, Link, SpacerVertical, TextField } from '@sodra/bongo-ui'
import { Col, Row } from 'jsxstyle/preact'
import { parse } from 'querystring'

import { resetPassword } from '../actions'

import logo from 'url:../logo.svg'
import { routeTo } from '@sodra/prutt'

const ResetPassword = ({ isResettingPassword }) => {
  const [password, setPassword] = useState('')
  const { token } = parse(location.search.slice(1))

  console.log({ token })

  const handleSubmit = async () => {
    if (await resetPassword({ password, token })) {
      routeTo('/', true)
    }
  }

  return (
    <Row
      position="absolute"
      top="0"
      left="0"
      bottom="0"
      right="0"
      alignItems="center"
      justifyContent="center"
      background="var(--surface)"
    >
      <Col alignItems="center">
        <img src={logo} width="100" />
        <SpacerVertical large />
        <Form width="240px" onSubmit={handleSubmit}>
          <TextField
            width="100%"
            type="password"
            label="Nytt lösenord"
            value={password}
            onInput={setPassword}
          />
          <SpacerVertical small />
          <Button contained type="submit" width="100%" loading={isResettingPassword}>
            Spara
          </Button>
        </Form>
        <SpacerVertical large />
        <Link to="/">Logga in</Link>
      </Col>
    </Row>
  )
}

export default connect('isResettingPassword')(ResetPassword)
